<template>
  <div>
    <v-snackbar v-model="error.show">
      <p class="py-0 my-0 font-weight-black">{{ error.title }}</p>
      {{ error.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-navigation-drawer v-model="drawer" :mini-variant="mini" app color="white" permanent class="sidebar-custom">
      <v-list-item class="px-2 py-4" style="border-bottom: 2px solid #1976D2;">
        <v-list-item-avatar v-if="!mini" color="blue" class="mr-2">
          <v-icon color="white">mdi-account-circle-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-title v-if="!mini" class="text-h6 blue--text text--darken-2 font-weight-bold">
          Painel
        </v-list-item-title>

        <v-btn icon @click.stop="mini = !mini" color="blue">
          <v-icon>{{ mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
        </v-btn>
      </v-list-item>

      <v-list dense nav class="pt-2">
        <!-- Início -->
        <v-list-item link to="/inicio" color="grey">
          <v-list-item-icon>
            <v-icon color="grey">mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Início</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Dashboard -->
        <v-list-item link to="/dashboard" color="grey">
          <v-list-item-icon>
            <v-icon color="grey">mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Clientes -->
        <v-list-item link to="/lista" color="grey">
          <v-list-item-icon>
            <v-icon color="grey">mdi-account-group</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Clientes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Financeiro -->
        <v-list-item link @click="irParaFaturas()" :class="{ 'v-list-item--active': isFinanceiroActive }">
          <v-list-item-icon>
            <v-icon :color="isFinanceiroActive ? '#1976D2' : 'grey'">mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              :class="isFinanceiroActive ? 'blue--text text--darken-2' : 'grey--text'">Financeiro</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Integrações -->
        <v-list-group prepend-icon="mdi-connection" color="grey" no-action>
          <template v-slot:activator>
            <v-list-item-title class="grey--text">Integrações</v-list-item-title>
          </template>

          <v-list-item link @click="verificarWhatsApp()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-whatsapp</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">WhatsApp</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="carregarAsaas()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-cash-clock</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Asaas</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Links úteis -->
        <v-list-group prepend-icon="mdi-link-variant" color="grey" no-action>
          <template v-slot:activator>
            <v-list-item-title class="grey--text">Links úteis</v-list-item-title>
          </template>

          <v-list-item link @click="irParaGuia()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-cast-education</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Guia rápido</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaApoio()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-handshake</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Apoio ao parceiro</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaApoioSuporte()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-face-agent</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Apoio ao suporte</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaYoutube()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-youtube-tv</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Biblioteca de treinamentos</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaBancoImagens()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-image-area</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Banco de imagens</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaAjuda()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-help-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Central de ajuda</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaStatus()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-server-network</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Status</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaSugestoes()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-gesture-tap-button</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Feedback</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaDoc()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-api</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Documentação da API</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="irParaComunidade()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-whatsapp</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Comunidade WhatsApp</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Gerenciamento -->
        <v-list-group prepend-icon="mdi-cog-outline" color="grey" no-action v-if="!isRevenda || isDesenvolvimento">
          <template v-slot:activator>
            <v-list-item-title class="grey--text">Gerenciamento</v-list-item-title>
          </template>

          <v-list-item link @click="carregarInstalacoes()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-laptop</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Instalações</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="carregarRevendas()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-store</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Revendas</v-list-item-title>
          </v-list-item>

          <v-list-item link @click="carregarTransacoes()" class="pl-8">
            <v-list-item-icon>
              <v-icon color="grey">mdi-bank-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="grey--text">Transações</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-divider class="my-2"></v-divider>

        <!-- Ajustes -->
        <v-list-item link @click="abrirAjustes()" color="grey">
          <v-list-item-icon>
            <v-icon color="grey">mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Ajustes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Sair -->
        <v-list-item link @click="sair()">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="grey--text">Sair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-card @click="carregarRevenda()" class="credit-card" elevation="2" hover>
            <v-card-text class="d-flex align-center pa-3">
              <v-icon :color="mostrarCreditos ? 'blue' : 'grey'" class="mr-3">
                {{ mostrarCreditos ? 'mdi-eye' : 'mdi-eye-off' }}
              </v-icon>
              <div v-if="!mini" class="flex-grow-1">
                <div class="caption grey--text">Créditos</div>
                <div class="font-weight-bold" :class="mostrarCreditos ? 'blue--text' : ''">
                  {{ mostrarCreditos ? formatarMoeda(revenda.creditos) : '••••' }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </template>

      <!-- Diálogo WhatsApp -->
      <v-dialog v-model="dialogWhatsApp" max-width="600px">
        <v-card>
          <v-card-title class="success white--text">
            <v-icon left color="white">mdi-whatsapp</v-icon>
            <span class="headline">WhatsApp</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogWhatsApp = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 70vh; overflow-y: auto;">
            <p class="mt-2">Conecte-se no WhatsApp para enviar notificações automáticas aos seus clientes.</p>

            <v-container class="text-center">
              <img :src="qrcode" width="300" height="300" />
            </v-container>

            <p>Aponte a câmera do seu celular em até 1 minuto, caso contrário será necessário gerar outro QR Code.</p>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogWhatsApp = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Asaas -->
      <v-dialog v-model="dialogAsaas" max-width="600px">
        <v-card>
          <v-card-title class="warning white--text">
            <v-icon left color="white">mdi-cash-clock</v-icon>
            <span class="headline">Asaas</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogAsaas = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 70vh; overflow-y: auto;">
            <p class="mt-2">Deixe tudo no automático, automatize a cobrança dos seus clientes com Asaas de maneira fácil e
              eficaz.</p>

            <v-container>
              <h3 class="mt-3 blue--text">Informações</h3>
              <hr class="mb-3 mt-2" />

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" v-model="webhookUrl" label="URL do Webhook"
                    hint="É uma url específica do painel para recebimento dos eventos" type="text" filled readonly
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <h3 class="mt-3 blue--text">Tutoriais</h3>
              <hr class="mb-3 mt-2" />

              <p class="mt-3">Passo 1) Deixe tudo no automático ativando o webhook no Asaas de maneira fácil e eficaz.</p>
              <div style="padding:56% 0 0 0;position:relative;">
                <iframe
                  src="https://player.vimeo.com/video/1045382913?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&autoplay=1&title=0&sidedock=0"
                  frameborder="0" allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  style="position:absolute;top:0;left:0;width:100%;height:100%;"
                  title="Automatização das assinaturas com Asaas"></iframe>
              </div>

              <p class="mt-3">Passo 2) Agora precisamos gerar o seu token para alterar aqui no painel.</p>
              <div style="padding:56% 0 0 0;position:relative;">
                <iframe
                  src="https://player.vimeo.com/video/1060614793?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&title=0&sidedock=0"
                  frameborder="0" allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  style="position:absolute;top:0;left:0;width:100%;height:100%;"
                  title="Automatização das assinaturas com Asaas"></iframe>
              </div>

              <p class="mt-5">Passo 3) Após a ativação, basta cadastrar as assinaturas dos seus clientes e o Asaas irá
                automatizar a cobrança.</p>
              <div style="padding:46% 0 0 0;position:relative;">
                <iframe
                  src="https://player.vimeo.com/video/1053042863?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&title=0&sidedock=0"
                  frameborder="0" allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  style="position:absolute;top:0;left:0;width:100%;height:100%;"
                  title="Automatização das assinaturas com Asaas"></iframe>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogAsaas = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Ajustes -->
      <v-dialog v-model="dialogAjustes" max-width="600px">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-cog</v-icon>
            <span class="headline">Ajustes</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogAjustes = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="max-height: 70vh; overflow-y: auto;">
            <v-container>
              <h3 class="mt-3 blue--text">Informações do responsável</h3>
              <hr class="mb-3 mt-2" />

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" v-model="inputs.nome_empresa" label="Empresa"
                    hint="Nome da empresa ou responsável" type="text" filled required persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.nome_sistema" label="Sistema" hint="Nome do sistema"
                    type="text" filled required persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.email" label="Email" hint="Email de contato" type="email"
                    filled required persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.telefone" label="Telefone" hint="Telefone de contato"
                    type="text" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <h3 class="mt-3 blue--text">Identificações</h3>
              <hr class="mb-3 mt-2" />

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" v-model="inputs.ajuda" label="Ajuda" hint="Link de ajuda para os clientes"
                    type="text" filled required persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.jivochat" label="Jivochat"
                    hint="Código de identificação do chat" type="text" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <h3 class="mt-3 blue--text">Limites</h3>
              <hr class="mb-3 mt-2" />

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" v-model="inputs.limite_emissao_fiscal_mes" label="Emissão fiscal - NFC-e"
                    hint="Limite de emissões fiscais de NFC-e por mês" type="number" filled required
                    persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.limite_emissao_fiscal_nfe_mes" label="Emissão fiscal - NF-e"
                    hint="Limite de emissões fiscais de NF-e por mês" type="number" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <h3 class="mt-3 blue--text">Tokens da {{ inputs.nome_empresa }}</h3>
              <hr class="mb-3 mt-2" />

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" v-model="inputs.asaas_token" label="Token Asaas"
                    hint="Token secreto da plataforma do Asaas" type="text" filled required
                    persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.token_gpt" label="Token ChatGPT"
                    hint="Token secreto da plataforma da openapi" type="text" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <h3 class="mt-3 blue--text">E-mail (SMTP)</h3>
              <hr class="mb-3 mt-2" />

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-switch v-model="inputs.smtp_autenticacao" label="Autenticação" :true-value="true"
                    :false-value="false"></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" v-model="inputs.smtp_email" label="E-mail" hint="E-mail para autenticação"
                    type="email" filled required persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.smtp_senha" label="Senha" hint="Senha para autenticação"
                    type="password" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" label="Protocolo" hint="SMTP" type="text" value="tls" filled readonly
                    persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.smtp_host" label="Host" hint="SMTP" type="text" filled
                    required persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.smtp_porta" label="Porta" hint="SMTP" type="number" filled
                    required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <h3 class="mt-3 blue--text">Precificação dos planos</h3>
              <hr class="mb-3 mt-2" />

              <div v-for="(plano, index) in planos" :key="index">
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="inputs[`preco_plano_${plano.value}`]" :label="`Plano ${plano.text}`"
                      hint="Defina o preço para mensalidade do plano" type="text" prefix="R$" filled required
                      persistent-hint></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <h3 class="mt-3 blue--text">Precificação adicional</h3>
              <hr class="mb-3 mt-2" />

              <!-- PDV -->
              <v-row>
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_pdv" :items="planos" label="Plano - PDV" hint="Selecione o plano"
                    filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_pdv" label="Preço - PDV" hint="Defina o preço para venda"
                    type="text" prefix="R$" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Mesas -->
              <v-row>
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_mesas" :items="planos" label="Plano - Mesas"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_mesas" label="Preço - Mesas" hint="Defina o preço para venda"
                    type="text" prefix="R$" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- App Motoboy -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_app_motoboy" :items="planos" label="Plano - App Motoboy"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_app_motoboy" label="Preço - App Motoboy"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Monitor de Senhas -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_senhas" :items="planos" label="Plano - Monitor de Senhas"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_senhas" label="Preço - Monitor de Senhas"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Monitor de Preparos -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_preparo" :items="planos" label="Plano - Monitor de Preparos"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_preparo" label="Preço - Monitor de Preparos"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Monitor de Balanças -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_balanca" :items="planos" label="Plano - Monitor de Balanças"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_balanca" label="Preço - Monitor de Balanças"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Monitor de Entregas -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_entregas" :items="planos" label="Plano - Monitor de Entregas"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_entregas" label="Preço - Monitor de Entregas"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Financeiro -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_financeiro" :items="planos" label="Plano - Financeiro"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_financeiro" label="Preço - Financeiro"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Controle de Estoque -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_estoque" :items="planos" label="Plano - Controle de Estoque"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_estoque" label="Preço - Controle de Estoque"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Integrações -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_integracoes" :items="planos" label="Plano - Integrações"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_integracoes" label="Preço - Integrações"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Fidelização de clientes -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_marketing" :items="planos"
                    label="Plano - Fidelização de clientes" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_marketing" label="Preço - Fidelização de clientes"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Campanhas -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_campanhas" :items="planos" label="Plano - Campanhas"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_campanhas" label="Preço - Campanhas"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Campanhas por SMS -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_marketing_sms" :items="planos" label="Plano - Campanhas por SMS"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_marketing_sms" label="Preço - Campanhas por SMS"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Campanhas por WhatsApp -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_marketing_whatsapp_marketing" :items="planos"
                    label="Plano - Campanhas por WhatsApp" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_marketing_whatsapp_marketing"
                    label="Preço - Campanhas por WhatsApp" hint="Defina o preço para venda" type="text" prefix="R$" filled
                    required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Campanhas por E-mail -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_marketing_email_marketing" :items="planos"
                    label="Plano - Campanhas por E-mail" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_marketing_email_marketing"
                    label="Preço - Campanhas por E-mail" hint="Defina o preço para venda" type="text" prefix="R$" filled
                    required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Campanhas por Push -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_marketing_notificacao_push" :items="planos"
                    label="Plano - Campanhas por Push" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_marketing_notificacao_push"
                    label="Preço - Campanhas por Push" hint="Defina o preço para venda" type="text" prefix="R$" filled
                    required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Chat -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_chat" :items="planos" label="Plano - Chat"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_chat" label="Preço - Chat" hint="Defina o preço para venda"
                    type="text" prefix="R$" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Gerente Dedicado -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_gerente_dedicado" :items="planos"
                    label="Plano - Gerente Dedicado" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_gerente_dedicado" label="Preço - Gerente Dedicado"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Suporte Dedicado -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_suporte_dedicado" :items="planos"
                    label="Plano - Suporte Dedicado" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_suporte_dedicado" label="Preço - Suporte Dedicado"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Domínio Próprio -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_dominio_proprio" :items="planos" label="Plano - Domínio Próprio"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_dominio_proprio" label="Preço - Domínio Próprio"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Emissor Fiscal (NFC-e) -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_fiscal" :items="planos" label="Plano - Emissor Fiscal (NFC-e)"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_fiscal" label="Preço - Emissor Fiscal (NFC-e)"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Emissor Fiscal (NF-e) -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_fiscal_nfe" :items="planos" label="Plano - Emissor Fiscal (NF-e)"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_fiscal_nfe" label="Preço - Emissor Fiscal (NF-e)"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Distribuição NF-e (DFe) -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_dfe" :items="planos" label="Plano - Distribuição NF-e (DFe)"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_dfe" label="Preço - Distribuição NF-e (DFe)"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Robô de Atendimento -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_whatsapp_robo_atendimento" :items="planos"
                    label="Plano - Robô de Atendimento" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_whatsapp_robo_atendimento"
                    label="Preço - Robô de Atendimento" hint="Defina o preço para venda" type="text" prefix="R$" filled
                    required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Ifood -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_ifood" :items="planos" label="Plano - Ifood"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_ifood" label="Preço - Ifood" hint="Defina o preço para venda"
                    type="text" prefix="R$" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Certificado digital -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_certificado_digital" :items="planos" label="Plano - Certificado digital"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_certificado_digital" label="Preço - Certificado digital"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Campanhas agendadas -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_cron" :items="planos" label="Plano - Campanhas agendadas"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_cron" label="Preço - Campanhas agendadas"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Google Meu Negócio -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_google_meu_negocio" :items="planos"
                    label="Plano - Google Meu Negócio" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_google_meu_negocio" label="Preço - Google Meu Negócio"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Consultoria Estratégica -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_consultoria_estrategica" :items="planos"
                    label="Plano - Consultoria Estratégica" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_consultoria_estrategica"
                    label="Preço - Consultoria Estratégica" hint="Defina o preço para venda" type="text" prefix="R$"
                    filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- Consultoria iFood -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_consultoria_ifood" :items="planos"
                    label="Plano - Consultoria iFood" hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_consultoria_ifood" label="Preço - Consultoria iFood"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- G-TOTEM -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_totem" :items="planos" label="Plano - G-TOTEM"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_totem" label="Preço - G-TOTEM"
                    hint="Defina o preço para venda" type="text" prefix="R$" filled required
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- G-POS -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_gpos" :items="planos" label="Plano - G-POS"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_gpos" label="Preço - G-POS" hint="Defina o preço para venda"
                    type="text" prefix="R$" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- G-TEF -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_gtef" :items="planos" label="Plano - G-TEF"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_gtef" label="Preço - G-TEF" hint="Defina o preço para venda"
                    type="text" prefix="R$" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <!-- G-ZAP -->
              <v-row class="mb-2">
                <v-col cols="12" sm="6">
                  <v-select v-model="inputs.plano_modulo_gzap" :items="planos" label="Plano - G-ZAP"
                    hint="Selecione o plano" filled persistent-hint></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="inputs.preco_modulo_gzap" label="Preço - G-ZAP" hint="Defina o preço para venda"
                    type="text" prefix="R$" filled required persistent-hint></v-text-field>
                </v-col>
              </v-row>

              <h3 class="mt-3 blue--text">Interno</h3>
              <hr class="mb-3 mt-2" />

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field class="mb-2" v-model="inputs.site" label="Site" hint="Site da empresa sem http:// ou www."
                    type="url" filled required readonly persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.logo" label="Identificação da logo"
                    hint="Identificação interna da logomarca" type="text" filled required readonly
                    persistent-hint></v-text-field>

                  <v-text-field class="mb-2" v-model="inputs.asaas_id_revenda" label="Identificação Asaas"
                    hint="Identificação interna para cobranças das faturas" type="text" filled required readonly
                    persistent-hint></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogAjustes = false">
              Cancelar
            </v-btn>
            <v-btn color="blue darken-1" text @click="salvarResponsavel()">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Instalações -->
      <v-dialog v-model="dialogInstalacoes" max-width="1024px">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-laptop</v-icon>
            <span class="headline">Instalações</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogInstalacoes = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 70vh; overflow-y: auto;" class="pa-0">
            <v-data-table :headers="headersInstalacoes" :items="instalacoes"
              @dblclick:row="($event, { item }) => acessarCliente(item)" class="elevation-1" locale="pt" sort-by="nome">
              <template v-slot:item.data_modificacao="{ item }">
                <span>{{ new Date(item.data_modificacao).toLocaleString('pt-br') }}</span>
              </template>

              <template v-slot:item.data_criacao="{ item }">
                <span>{{ new Date(item.data_criacao).toLocaleString('pt-br') }}</span>
              </template>

              <template v-slot:item.dados.analytics.totalPedidos="{ item }">
                {{ item.dados.analytics.totalPedidos | formatNumber }}
              </template>

              <template v-slot:item.dados.analytics.totalFaturamento="{ item }">
                {{ Number(item.dados.analytics.totalFaturamento).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }) }}
              </template>

            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogInstalacoes = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Revendas -->
      <v-dialog v-model="dialogRevendas" max-width="1024px">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-laptop-account</v-icon>
            <span class="headline">Revendas</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogRevendas = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 70vh; overflow-y: auto;" class="pa-0">
            <v-data-table :headers="headersRevendas" :items="revendas"
              @dblclick:row="($event, { item }) => acessarRevenda(item)" class="elevation-1" locale="pt" sort-by="nome">
              <template v-slot:item.data_modificacao="{ item }">
                <span>{{ new Date(item.data_modificacao).toLocaleString('pt-br') }}</span>
              </template>

              <template v-slot:item.data_criacao="{ item }">
                <span>{{ new Date(item.data_criacao).toLocaleString('pt-br') }}</span>
              </template>

              <template v-slot:item.creditos="{ item }">
                {{ Number(item.creditos).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }) }}
              </template>

            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogRevendas = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Transações -->
      <v-dialog v-model="dialogTransacoes" max-width="1024px">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-bank-transfer</v-icon>
            <span class="headline">Transações de créditos</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogTransacoes = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 70vh; overflow-y: auto;" class="pa-0">
            <v-data-table :headers="headersTransacoes" :items="transacoes"
              @dblclick:row="($event, { item }) => acessarRevenda(item)" class="elevation-1" locale="pt"
              sort-by="data_criacao" sort-desc>
              <template v-slot:item.data_criacao="{ item }">
                <span>{{ new Date(item.data_criacao).toLocaleString('pt-br') }}</span>
              </template>

              <template v-slot:item.data_modificacao="{ item }">
                <span>{{ new Date(item.data_modificacao).toLocaleString('pt-br') }}</span>
              </template>

              <template v-slot:item.creditos="{ item }">
                {{ Number(item.creditos).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }) }}
              </template>

              <template v-slot:item.valor="{ item }">
                {{ Number(item.valor).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }) }}
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogTransacoes = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Créditos -->
      <v-dialog v-model="dialogCreditos" max-width="600px">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-bank</v-icon>
            <span class="headline">Créditos</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogCreditos = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 70vh; overflow-y: auto;">
            <v-container>
              <h4 class="mb-3 success--text">Sabia que ao adicionar créditos antecipadamente você ganha 10% de desconto?
                adicione agora mesmo!</h4>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field label="Empresa" :value="revenda.nome" filled readonly persistent-hint></v-text-field>
                  <v-text-field label="Saldo" hint="Seu saldo em créditos para descontar na próxima fatura"
                    :value="revenda.creditos" type="number" prefix="R$" filled readonly persistent-hint></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogCreditos = false">
              Fechar
            </v-btn>
            <v-btn color="success darken-1" text @click="abrirAdicionarCreditos()">
              Adicionar créditos
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Adicionar Créditos -->
      <v-dialog v-model="dialogAddCreditos" max-width="600px">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-bank</v-icon>
            <span class="headline">Adicionar créditos</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogAddCreditos = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 70vh; overflow-y: auto;">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field label="Créditos" v-model="inputsCreditos.creditos" value="0,00" type="number" min="5"
                    max="100000" prefix="R$" filled persistent-hint></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogAddCreditos = false">
              Fechar
            </v-btn>
            <v-btn color="success darken-1" text @click="adicionarCreditos()">
              Adicionar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { encerrar } from '../../utils/utils'
import { verificarInstanciaGamazap, iniciarInstanciaGamazap, responsavelGeralDados, responsavelGeralSalvar, listarInstalacoes, listarRevendas, listarTransacoes, validarRevenda, asaasCriarFatura } from '../../services/api'

export default {
  name: 'Sidebar',
  data() {
    return {
      drawer: true,
      mini: false,
      dialogWhatsApp: false,
      dialogAsaas: false,
      dialogAjustes: false,
      dialogInstalacoes: false,
      dialogRevendas: false,
      dialogTransacoes: false,
      dialogCreditos: false,
      dialogAddCreditos: false,
      qrcode: '',
      webhookUrl: '',
      token: localStorage.getItem("token"),
      inputs: {},
      inputsCreditos: {},
      instalacoes: [],
      revendas: [],
      transacoes: [],
      revenda: {
        creditos: 0.00,
        nome: '',
      },
      mostrarCreditos: false,
      error: {
        show: false,
        title: "",
        message: "",
      },
      headersInstalacoes: [
        {
          text: "UF",
          align: "start",
          value: "dados.endereco.uf",
        },
        {
          text: "Cidade",
          value: "dados.endereco.cidade",
        },
        {
          text: "Empresa",
          value: "dados.empresa.nome",
        },
        {
          text: "Loja",
          value: "nome",
        },
        {
          text: "Versão",
          value: "dados.instalacao.versao",
        },
        { text: "Pedidos", value: "dados.analytics.totalPedidos" },
        { text: "Faturamento", value: "dados.analytics.totalFaturamento" },
        { text: "Última verificação", value: "data_modificacao" },
        { text: "Cadastrado em", value: "data_criacao" },
      ],
      headersRevendas: [
        { text: "Revenda", value: "nome" },
        { text: "Créditos", value: "creditos" },
        { text: "Última verificação", value: "data_modificacao" },
        { text: "Cadastrado em", value: "data_criacao" },
      ],
      headersTransacoes: [
        { text: "Revenda", value: "revenda" },
        { text: "ID Transação", value: "id_transacao" },
        { text: "Valor", value: "valor" },
        { text: "Créditos", value: "creditos" },
        { text: "Atualização", value: "data_modificacao" },
        { text: "Data", value: "data_criacao" },
      ]
    }
  },
  computed: {
    isFinanceiroActive() {
      return this.$route.path.includes('/faturas');
    },
  },
  methods: {
    setError(error, title) {
      console.error(title, error);
      this.error = {
        show: true,
        title: title ? title : "Ops, falhou!",
        message: error ? error : "Falha não identificada, tente novamente.",
      };
    },
    irParaGuia() {
      window.open(`https://meajuda.gitbook.io/guia-rapido`, "_blank");
    },
    irParaApoio() {
      window.open(`https://meajuda.gitbook.io/guia-do-parceiro`, "_blank");
    },
    irParaApoioSuporte() {
      window.open(`https://meajuda.gitbook.io/apoio-suporte`, "_blank");
    },
    irParaYoutube() {
      window.open(`https://www.youtube.com/watch?v=cbe26GvSgNE&list=PLhYrlp37bmCHY-fwZLjSyFN-g63sxCM-B`, "_blank");
    },
    irParaBancoImagens() {
      window.open(`https://drive.google.com/drive/u/0/folders/0AE94F7UtwJUNUk9PVA`, "_blank");
    },
    irParaAjuda() {
      window.open(`https://ajuda${this.url}`, "_blank");
    },
    irParaStatus() {
      window.open(`https://status.gamadelivery.app`, "_blank");
    },
    irParaSugestoes() {
      window.open(`https://feedback.userreport.com/599d3d3c-510b-4cdc-8524-cef4d7fb701e/#submit/idea`, "_blank");
    },
    irParaDoc() {
      window.open(`https://documenter.getpostman.com/view/8002308/2s9YXiYLjW`, "_blank");
    },
    irParaComunidade() {
      window.open(`https://chat.whatsapp.com/BXNoLXR8ltN34KXeRA7XDF`, "_blank");
    },
    sair() {
      return encerrar();
    },
    irParaFaturas() {
      const asaasIdRevenda = localStorage.getItem('asaas_id_revenda') || '';
      if (asaasIdRevenda) {
        const targetPath = `/faturas/${asaasIdRevenda}`;
        if (this.$route.path !== targetPath) {
          this.$router.push({ path: targetPath });
        }
      } else {
        this.setError('Ainda não disponível para sua conta, tente novamente mais tarde.');
      }
    },
    abrirAjustes() {
      this.carregarResponsavel();
    },
    carregarResponsavel() {
      this.inputs = {};
      this.$root.$emit('global-loading', true);
      responsavelGeralDados(this.token)
        .then((response) => {
          this.$root.$emit('global-loading', false);
          this.inputs = response.data?.responsavel;
          this.dialogAjustes = true;
        })
        .catch((error) => {
          this.$root.$emit('global-loading', false);
          this.setError(error?.response?.data?.message || 'Erro ao carregar dados');
        });
    },
    salvarResponsavel() {
      this.dialogAjustes = false;
      this.$root.$emit('global-loading', true);
      responsavelGeralSalvar(this.token, this.inputs)
        .then(() => {
          this.$root.$emit('global-loading', false);
        })
        .catch((error) => {
          this.dialogAjustes = true;
          this.$root.$emit('global-loading', false);
          this.setError(error?.response?.data?.message || 'Erro ao salvar');
        });
    },
    verificarWhatsApp() {
      this.$root.$emit('global-loading', true);
      verificarInstanciaGamazap(this.token)
        .then(() => {
          this.$root.$emit('global-loading', false);
          this.setError("O seu WhatsApp está conectado!", "Conectado!");
        })
        .catch(() => {
          this.conectarWhatsApp();
        });
    },
    conectarWhatsApp() {
      iniciarInstanciaGamazap(this.token)
        .then((response) => {
          this.$root.$emit('global-loading', false);
          this.qrcode = response?.data?.qrcode?.base64;
          if (this.qrcode) {
            this.dialogWhatsApp = true;
            setTimeout(() => this.dialogWhatsApp = false, 60000);
          }
        })
        .catch((error) => {
          this.dialogWhatsApp = true;
          this.$root.$emit('global-loading', false);
          this.setError(error?.response?.data?.message || 'Erro ao conectar WhatsApp');
        });
    },
    carregarAsaas() {
      const apiKey = localStorage.getItem('api_key') || '';
      this.webhookUrl = `${window.location.origin}/api_asaas.php?apiKey=${apiKey}`;
      this.dialogAsaas = true;
    },
    carregarInstalacoes() {
      this.$root.$emit('global-loading', true);
      listarInstalacoes(this.token)
        .then((response) => {
          this.$root.$emit('global-loading', false);
          let lista = [];
          response.data.map((instalacao) => {
            instalacao.dados = JSON.parse(instalacao.dados);
            lista.push(instalacao);
          })
          this.instalacoes = lista;
          this.dialogInstalacoes = true;
        })
        .catch((error) => {
          this.$root.$emit('global-loading', false);
          this.setError(error?.response?.data?.message || 'Erro ao carregar instalações');
        });
    },
    carregarRevendas() {
      this.$root.$emit('global-loading', true);
      listarRevendas(this.token)
        .then((response) => {
          this.$root.$emit('global-loading', false);
          this.revendas = response.data;
          this.dialogRevendas = true;
        })
        .catch((error) => {
          this.$root.$emit('global-loading', false);
          this.setError(error?.response?.data?.message || 'Erro ao carregar revendas');
        });
    },
    carregarTransacoes() {
      this.$root.$emit('global-loading', true);
      listarTransacoes(this.token)
        .then((response) => {
          this.$root.$emit('global-loading', false);
          this.transacoes = response.data;
          this.dialogTransacoes = true;
        })
        .catch((error) => {
          this.$root.$emit('global-loading', false);
          this.setError(error?.response?.data?.message || 'Erro ao carregar transações');
        });
    },
    acessarCliente(cliente) {
      window.open(`https://${cliente.url}/acesso-adm`, "_blank");
    },
    acessarRevenda(revenda) {
      window.open(`https://${revenda.url}/`, "_blank");
    },
    formatarMoeda(valor) {
      return parseFloat(valor || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    },
    async buscarRevenda() {
      const { data: revenda } = await responsavelGeralDados(this.token);
      const { data: dados } = await validarRevenda(this.dominio, revenda.responsavel?.nome_empresa);
      return { ...dados.data, api_key: revenda.responsavel?.api_key };
    },
    carregarRevenda() {
      const asaasIdRevenda = localStorage.getItem('asaas_id_revenda') || '';
      if (!asaasIdRevenda) {
        this.setError('Ainda não disponível para sua conta, tente novamente mais tarde.');
        return;
      }

      if (!this.mostrarCreditos) {
        this.$root.$emit('global-loading', true);
        this.buscarRevenda()
          .then((revenda) => {
            this.revenda = revenda;
            this.$root.$emit('global-loading', false);
            this.mostrarCreditos = true;
            this.dialogCreditos = true;
          })
          .catch((error) => {
            this.setError(error?.message || 'Erro ao carregar créditos');
            this.$root.$emit('global-loading', false);
          });
      } else {
        this.mostrarCreditos = false;
      }
    },
    abrirAdicionarCreditos() {
      this.dialogCreditos = false;
      this.dialogAddCreditos = true;
      this.inputsCreditos = {};
    },
    adicionarCreditos() {
      this.$root.$emit('global-loading', true);
      this.dialogAddCreditos = false;

      const token = Math.random().toString(36).substring(2);
      const asaasIdRevenda = localStorage.getItem('asaas_id_revenda');

      asaasCriarFatura(this.token, {
        billingType: "PIX",
        customer: asaasIdRevenda,
        dueDate: new Date(),
        value: (this.inputsCreditos.creditos - (this.inputsCreditos.creditos * 0.10)),
        description: `${this.isDesenvolvimento ? '(DEV)' : ''} ${this.inputsCreditos.creditos} créditos`,
        externalReference: token,
        split: [
          {
            walletId: (this.isDesenvolvimento ? "7171bb1c-f2d2-4729-bf08-ec90431ccaf5" : "ec7ac8c2-9e1f-44c9-9d6e-bae9088523ea"),
            percentualValue: 25,
          },
        ],
        callback: {
          successUrl: `https://painel.gamadelivery.app/api_asaas_credito${this.isDesenvolvimento ? '-dev' : ''}.php?customer=${asaasIdRevenda}&url=${this.revenda.url}&token=${token}&apiKey=${this.revenda.api_key}`,
          autoRedirect: true,
        },
      }).then(({ data }) => {
        window.location.href = data.fatura?.invoiceUrl;
      }).catch((error) => {
        this.setError(error.response?.data?.message || 'Erro ao adicionar créditos');
        this.$root.$emit('global-loading', false);
      });
    }
  }
}
</script>

<style scoped>
.sidebar-custom {
  border-right: 1px solid #E0E0E0 !important;
}

.v-navigation-drawer {
  z-index: 999;
}

.v-list-item--active {
  background-color: #E3F2FD !important;
  border-left: 4px solid #1976D2;
}

.v-list-item--active .v-list-item__title,
.v-list-item--active .v-icon {
  color: #1976D2 !important;
  font-weight: 600;
}

.v-list-item:hover {
  background-color: #F5F5F5;
}

.v-list-item:hover .v-list-item__title,
.v-list-item:hover .v-icon {
  color: #1976D2 !important;
}

.v-list-group__header .v-list-item__icon {
  margin-right: 16px;
}

.v-list-group__header .v-list-item__icon .v-icon {
  color: #757575 !important;
}

.v-list-group--active>.v-list-group__header .v-list-item__icon .v-icon {
  color: #1976D2 !important;
}

.v-list-group--active>.v-list-group__header .v-list-item__title {
  color: #1976D2 !important;
  font-weight: 600;
}

.credit-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.credit-card:hover {
  border-left-color: #1976D2;
  transform: translateX(2px);
}
</style>
